import { useState, useEffect, useRef } from "react";
import { HiOutlineSpeakerWave } from "react-icons/hi2";
import { IoCall } from "react-icons/io5";
import { FaUserGroup } from "react-icons/fa6";
import { GoArrowLeft } from "react-icons/go";
import { BsSendFill } from "react-icons/bs";
import { IoSettingsOutline } from "react-icons/io5";
import { IoSearch } from "react-icons/io5";
import profile from "../../Assets/Images/profile.svg";
import { useGlobalContext } from "../../Context/GlobalContext";
import { timeSince } from "../../utils/helper";
import ChatComponent from "../../components/ChatComponent";
import Loader from "../../components/Loader";
import Groups from "../Staff_Panel/ChatTabs/Group";
import Admin from "../Staff_Panel/ChatTabs/Admin";
import ChatAnnouncementsModal from "./Chats/ChatAnnouncements";
import NewGroupChatModal from "./Chats/NewGroupModal";
import AddMembersSidePanel from "./Chats/AddMembersSidePanel";
import DeleteGroup from "./Chats/DeleteGroup";
import AddMembers from "./Chats/AddMembersModal";
import { MdGroups2 } from "react-icons/md";
import { TfiAnnouncement } from "react-icons/tfi";
import GroupChat from "./GroupChat";


const ClientChatInterFace = () => {
  const {
    setSelectedUser,
    messages,
    fetchOneOnOneChat,
    selectedUser,
    setMessages,
    message,
    setMessage,
    sendMessage,
    showChatSection,
    setShowChatSection,
    id,
    setId,
    handleSelectedUser,
    toggleSettings,
    showAnnouncementsModal,
    setShowAnnouncementsModal,
    showCreateGroupModal,
    setShowCreateGroupModal,
    AddMembersPanel,
    setShowAddMembersPanel,
    showDeleteGroupModal,
    setShowDeleteGroupModal,
    showAddMemberModal,
    setShowAddMemberModal,
    handleAddMembersModal,
    handleAddMembersPanel,
    handleAnnouncementsClick,
    handleCreateGroupClick,
    handleDeleteGroupClick,
    handleToggleSettings,
    setToggleSettings,
    isSendingMessage,
  } = useGlobalContext();
  const [chatTab, setChatTab] = useState("admins");
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (!e.target.closest("#settings-toggle")) {
        setToggleSettings(false);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);


  return (
    <div class="overflow-hidden">
      {/* <!-- Container for Chat Section --> */}
      <div class="flex bg-white shadow-lg rounded-lg h-[90vh] parent-container">
        {/* <!-- Left Section: Members List --> */}
        <div
          className={`w-full ${showChatSection ? "hidden sm:block" : "block"
            } sm:w-1/2 md:w-1/3 flex flex-col border-r-2 h-full bg-white overflow-hidden `}
        >
          <div className="flex flex-row justify-start items-center space-x-3 mb-2 pt-2 pb-5 pl-2 border-b h-[10%]">
            <div className="border-green-500 border rounded-full">
              <img src={profile} alt="" className="rounded-full w-9 h-9" />
            </div>
            <p className="font-medium text-xl">Kanika Arora</p>
          </div>
          {/* <!-- Search Bar --> */}
          <div className="flex flex-row justify-between items-center space-x-2 mx-4 h-[10%]">
            <div class="flex items-center border-gray-300 bg-white shadow-lg mt-3 mb-2 border rounded-full w-[90%]">
              <input
                type="text"
                placeholder="Search members..."
                class="bg-transparent py-2 pl-2 w-full font-normal text-sm outline-none"
              />
              <IoSearch className="mt-1 pr-2 text-[30px] text-gray-400" />
            </div>
            <div className="relative mt-1" id="settings-toggle">
              <div className="bg-purple-600 p-1 rounded-lg text-white">
                <IoSettingsOutline className="mt-1 text-[30px] text-white" onClick={handleToggleSettings} />
              </div>
              {toggleSettings && <div class="-right-20 z-10 absolute bg-white shadow-lg mt-2 rounded-md ring-1 ring-black/5 w-56 origin-top-right focus:outline-none" role="menu" aria-orientation="vertical" aria-labelledby="menu-button" tabindex="-1">
                <div class="py-1" role="none">
                  <a href="#" class="flex flex-row items-center px-4 py-2 text-gray-700 text-sm" role="menuitem" tabindex="-1" id="menu-item-0" onClick={handleAnnouncementsClick}><TfiAnnouncement className="mr-2" />Announcements</a>
                  <a href="#" class="flex flex-row items-center px-4 py-2 text-gray-700 text-sm" role="menuitem" tabindex="-1" id="menu-item-1" onClick={handleCreateGroupClick}><MdGroups2 className="mr-2" />Create Group</a>

                </div>
              </div>}
            </div>
          </div>
          {/* <!-- Member List --> */}
          <div className="flex flex-col flex-grow mb-4 px-3 h-[78%] overflow-y-auto">
            <div class="flex flex-row justify-start space-x-2 mb-4 md:w-[80%] xs:w-[100%]">
              <div
                className={`p-3 flex justify-start  items-center hover:text-black ${chatTab === "admins" ? "text-black" : "text-gray-400"}`}
                onClick={() => {
                  setChatTab("admins");
                }}
              >
                Admins
              </div>
              <div
                className={` p-3 flex justify-start items-center hover:text-black ${chatTab === "groups" ? "text-black" : "text-gray-400 "}`}
                onClick={() => {
                  setChatTab("groups");
                }}
              >
                Groups
              </div>
            </div>

            {chatTab === "admins" ? (
              <>
                <Admin handleSelectedUser={handleSelectedUser} />
              </>
            ) : (
              <Groups />
            )}


            {/* member column in ChatSection */}
          </div>
        </div>
        {/* <!-- Right Section: Chat Window --> */}

        <div
          className={`sm:w-1/2  md:w-2/3  md:flex flex-col flex-grow ${showChatSection ? "block sm:block" : "hidden sm:block"
            } chat-section`}
        >
          {chatTab === "admins" ? (
            !showChatSection ? (
              <div className="flex justify-center items-center h-full">
                <p className="font-semibold text-gray-400 text-lg">
                  Select a user to start chatting
                </p>
              </div>
            ) : (
              <div className="flex flex-col h-full">
                {/* Chat Header */}
                <div className="flex justify-between items-center mt-5 md:mt-0 pb-[6px] border-b">
                  <div className="relative flex flex-row justify-start items-center space-x-3 rounded-[100%] w-[70%] md:w-[50%]">
                    <div
                      className="float-left cursor-pointer"
                      onClick={() => setShowChatSection(false)}
                    >
                      <GoArrowLeft className="size-5" />
                    </div>
                    <div className="flex justify-center items-center border-gray-300 bg-purple-400 shadow-lg px-4 py-2 border rounded-full">
                      {selectedUser && selectedUser.name
                        ? selectedUser.name[0]
                        : "N/A"}
                    </div>
                    <div className="flex flex-col">
                      <h2 className="mt-2 font-normal text-md">
                        {selectedUser.name ?? "Not available"}
                      </h2>
                      <p className="text-gray-300 text-sm">last seen 3 hours ago</p>
                    </div>
                  </div>
                  <div className="flex space-x-2">
                    <HiOutlineSpeakerWave className="w-[30px] h-[30px] text-purple-600" />
                    <IoCall className="w-[25px] h-[30px] text-purple-600" />

                  </div>
                </div>
                {/* Chat Component */}
                <div className="flex flex-col justify-between h-full">
                  <ChatComponent messages={messages} />
                  {/* Message Input */}
                  <div className="flex items-center border-gray-300 mt-4 border chatBox">
                    <div className="relative w-[94%] chatInput">
                      <input
                        type="text"
                        value={message}
                        onChange={(e) => setMessage(e.target.value)}
                        placeholder="Send Message..."
                        className="p-2 pr-10 w-full"
                      />
                      <div className="right-0 absolute inset-y-0 flex items-center pr-3">
                        <IoSettingsOutline className="text-2xl text-gray-500" />
                      </div>
                    </div>
                    <button
                      onClick={sendMessage}
                      disabled={isSendingMessage}
                      className={`bg-purple-500 text-white flex justify-center items-center p-2 py-3 w-[6%] send-button ${isSendingMessage && "opacity-50"
                        }`}
                    >
                      <BsSendFill />
                    </button>
                  </div>
                </div>
              </div>
            )
          ) : (
            <GroupChat />
          )}
        </div>

      </div>
      {showAnnouncementsModal && (
        <ChatAnnouncementsModal
          onClose={() => setShowAnnouncementsModal(false)}
        />
      )}
      {showCreateGroupModal && (
        <NewGroupChatModal
          onClose={() => setShowCreateGroupModal(false)}
        />
      )}
      {showDeleteGroupModal && (
        <DeleteGroup
          onClose={() => setShowDeleteGroupModal(false)}
        />
      )}
      {showAddMemberModal && (
        <AddMembers
          onClose={() => setShowAddMemberModal(false)}
        />
      )}
    </div>
  );
};

export default ClientChatInterFace;